import { LocalStorageKey } from '@/shared/config';
import { safeLocalStorage } from '@/shared/lib';

export const savePresignUrl = (url: string): boolean =>
  safeLocalStorage.setItem(LocalStorageKey.preSignURL, url);

export const getPresignUrl = (): string | null =>
  safeLocalStorage.getItem(LocalStorageKey.preSignURL);

export const clearPresignUrl = (): void =>
  safeLocalStorage.removeItem(LocalStorageKey.preSignURL);
